import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TextLink } from '@weirgroup/one-weir';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { applicationRouteConstants } from '../../shared/_constants';
import styles from './main.module.css';
import PrivacyPolicy from '../../components/PrivacyPolicy';
import TermsConditions from '../../components/TermsConditions';
import CookiesPolicy from '../../components/CookiesPolicy';

function SiteInformation(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isAuthenticated } = props;

  const navigateBack = () => {
    if (isAuthenticated) {
      navigate(applicationRouteConstants.HUB, {
        state: { isAuthenticated: true },
      });
    } else {
      navigate(applicationRouteConstants.DEFAULT);
    }
  };

  return (
    <div className={styles.weirBackground}>
      <div className={styles.container}>
        <div className={styles.backButton}>
          <TextLink
            label={isAuthenticated ? t('hubLinkLbl') : t('loginLinkLbl')}
            color="blue"
            onClick={navigateBack}
          />
        </div>
        <PrivacyPolicy />
        <TermsConditions />
        <CookiesPolicy />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state?.AuthReducer?.isAuthenticated,
  };
};

export default connect(mapStateToProps)(SiteInformation);
